const STALE_SERVICE_WORKER_SCRIPT = "/sw.js";

function isStaleServiceWorkerRegistration(registration: ServiceWorkerRegistration): boolean {
  const workers = [registration.installing, registration.waiting, registration.active].filter(
    (worker): worker is ServiceWorker => worker !== null && worker !== undefined,
  );
  if (workers.length === 0) {
    return true;
  }
  return workers.some((worker) => worker.scriptURL.endsWith(STALE_SERVICE_WORKER_SCRIPT));
}

async function unregisterStaleServiceWorkers(): Promise<void> {
  if (!navigator.serviceWorker) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    const staleRegistrations = registrations.filter(isStaleServiceWorkerRegistration);
    await Promise.all(staleRegistrations.map((registration) => registration.unregister()));
    if (staleRegistrations.length > 0) {
      console.info(`[SW Cleanup] Unregistered ${staleRegistrations.length} stale service worker(s).`);
    }
  } catch (error) {
    console.error("[SW Cleanup] Failed to unregister stale service workers:", error);
  }
}

async function clearStaleServiceWorkerCaches(): Promise<void> {
  if (!window.caches) {
    return;
  }

  try {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
    if (cacheNames.length > 0) {
      console.info(`[SW Cleanup] Cleared ${cacheNames.length} stale cache(s).`);
    }
  } catch (error) {
    console.error("[SW Cleanup] Failed to clear stale caches:", error);
  }
}

export async function cleanupStaleServiceWorker(): Promise<void> {
  await unregisterStaleServiceWorkers();
  await clearStaleServiceWorkerCaches();
}
